import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Controller, useFormContext } from "react-hook-form";
import { getNestedError } from "../../../utils";
import { useEffect } from "react";

const MyCheckboxCircle = (props) => {
  const {
    name,
    onChange = () => {},
    required = false,
    disabled,
    ...rest
  } = props;

  const {
    watch,
    control,
    formState: { errors },
  } = useFormContext();

  const value = watch(name);

  useEffect(() => {
    onChange(value);
    // eslint-disable-next-line
  }, [value]);

  return (
    <div className={rest.className}>
      <div className="flex gap-2">
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <>
              <input type="checkbox" id={name} {...field} className="hidden" />
              <label
                htmlFor={name}
                className={`inline-flex justify-center items-center w-6 h-6 rounded-full border-2 cursor-pointer ${
                  field.value
                    ? "border-primary bg-primary"
                    : getNestedError(errors, name)
                    ? "border-error"
                    : "border-[#DBDBE4] bg-[#F1F1F5]"
                }`}
              >
                <FontAwesomeIcon
                  size="xs"
                  icon={faCheck}
                  color={
                    field.value
                      ? "white"
                      : getNestedError(errors, name)
                      ? "#e74c3c"
                      : "#DBDBE4"
                  }
                />
              </label>
              <label
                htmlFor={name}
                className={`text-[#767676] text-sm cursor-pointer flex items-center ${
                  rest?.labelClassName || ""
                }`}
              >
                {rest.label}{" "}
                {required && <span className="text-error text-sm">(필수)</span>}
              </label>
            </>
          )}
        />
      </div>
      {getNestedError(errors, name) && (
        <p
          className={`text-sm mt-1 ${
            getNestedError(errors, name) ? "text-error" : "text-[#999]"
          }`}
        >
          {getNestedError(errors, name)
            ? getNestedError(errors, name).message
            : ""}
        </p>
      )}
    </div>
  );
};

export default MyCheckboxCircle;
